import _ from 'lodash';
import { Component } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';

export type IScrollProps = RouteComponentProps<any> & { children: React.ReactNode };
class ScrollTop extends Component<IScrollProps> {
	public componentDidUpdate(prevProps: any) {
		if (!_.isEqual(this.props.location, prevProps.location)) {
			window.scrollTo(0, 0);
		}
	}

	public render() {
		return this.props.children;
	}
}

export const ScrollTopWrapper = withRouter(ScrollTop);
